import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

export var QuaterlyTargetThreeRes;
export const QuaterlyTargetThreeTodo = createAsyncThunk('QuaterlyTargetThree', async (data) => {
    

    var type = localStorage.getItem('type')
    try {
        const res = await axios({
            method: "post",
            url: process.env.REACT_APP_API_URL + 'quarterly_target_list',
            headers: { "Content-Type": "application/json" },
            data:
            {
                "vcust_plant_code": localStorage.getItem('vcust_plant_code'),
                "ibusiness_area_id": localStorage.getItem('ibusiness_area_id'),
                "iquater_id": "3",
                "iyear": '',
                "fin_year": localStorage.getItem('vfin_year').toString()

            }
        })
        return QuaterlyTargetThreeRes = res.data

    } catch (error) {
        return QuaterlyTargetThreeRes = error.response.data
    }
});

const QuaterlyTargetThreeSlice = createSlice({
    name: 'QuaterlyTargetThree',
    initialState: {
        data: null,
    },
    extraReducers: (builder) => {
        builder.addCase(QuaterlyTargetThreeTodo.fulfilled, (state, action) => {
            state.data = action.payload;
            // console.log('userList', state.data)
        });
        builder.addCase(QuaterlyTargetThreeTodo.rejected, (state, action) => {
            // console.log('token_error', action)
        })
    }
});

export default QuaterlyTargetThreeSlice.reducer; 